import { render } from "./NavigateView.vue?vue&type=template&id=09fab82c&ts=true"
import script from "./NavigateView.vue?vue&type=script&lang=ts"
export * from "./NavigateView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__